module.exports = __webpack_public_path__ + "static/media/password-switch-on.ccbccc58.svg";